import React, { useRef } from "react";
import FremontShowHide from "./FremontShowHide";
import JunkRemovalServices from "./JunkRemovalServices";
import JunkHauling from "./JunkHauling";

const JumpFremont = () => {
  const section2Ref = useRef(null);
  const handleScroll = () => {
    section2Ref.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div>
      {/* Section 1 with a Link */}
      <div id="section1">
        <div className="container">
          <div className="row trusted-service-section">
            <div className="col-lg-6 col-md-12">
              <div className="express-services-sec">
                <h2 className="junk-years-head">Junk Removal In Fremont</h2>
                <div className="border-bg">
                  <div className="sliderline-svg trusted-line-svg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="64"
                      height="4"
                      viewBox="0 0 64 4"
                      fill="none"
                    >
                      <path
                        d="M56.15 0H7.14C3.19669 0 0 0.895419 0 1.99999C0 3.10456 3.19669 4 7.14 4H56.15C60.0933 4 63.29 3.10456 63.29 1.99999C63.29 0.895419 60.0933 0 56.15 0Z"
                        fill="#2672FF"
                      />
                    </svg>
                  </div>
                </div>
                <h2>
                  EXPRESS <span>service</span>
                </h2>
                <div className="border-bg"></div>
                <div className="list-section">
                  <ul>
                    <li>No Extra Charges for Nights, Weekends, or Holidays</li>
                    <li>Free, No-Obligation Estimates</li>
                    <li>Full-Service Junk Removal for Home & Business</li>
                    <li>Equipped with State-of-the-Art Equipment</li>
                    <li>Licensed & Insured</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="our-services-sec">
                <h2>Our Services</h2>
                <div className="border-bg">
                  <div className="sliderline-svg trusted-line-svg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="64"
                      height="4"
                      viewBox="0 0 64 4"
                      fill="none"
                    >
                      <path
                        d="M56.15 0H7.14C3.19669 0 0 0.895419 0 1.99999C0 3.10456 3.19669 4 7.14 4H56.15C60.0933 4 63.29 3.10456 63.29 1.99999C63.29 0.895419 60.0933 0 56.15 0Z"
                        fill="#2672FF"
                      />
                    </svg>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 pe-0">
                    <div className="service-section things-remove">
                      <div className="dont-need">
                        <img
                          src="/assets/img/appliance-removal-icon.svg"
                          alt=""
                          loading="lazy"
                        />
                      </div>
                      <a href="/services/appliance-removal/">
                        <p>Appliance Removal</p>
                      </a>
                    </div>
                    <div className="service-section things-remove">
                      <div className="dont-need const-sec">
                        <img
                          src="/assets/img/storage-icon.svg"
                          alt=""
                          loading="lazy"
                        />
                      </div>
                      <a href="/services/storage-unit-cleanouts/">
                        <p>Storage Unit Cleanout</p>
                      </a>
                    </div>
                    <div className="service-section things-remove">
                      <div className="dont-need">
                        <img
                          src="/assets/img/furniture-icon.svg"
                          alt=""
                          loading="lazy"
                        />
                      </div>
                      <a href="/services/furniture-removal/">
                        <p>Furniture Removal</p>
                      </a>
                    </div>
                    <div className="service-section things-remove">
                      <div className="dont-need">
                        <img
                          src="/assets/img/appliance-icon.svg"
                          alt=""
                          loading="lazy"
                        />
                      </div>
                      <a href="/services/appliance-removal/">
                        <p>Appliance Removal</p>
                      </a>
                    </div>
                  </div>
                  <div className="col-md-6 p-0">
                    <div className="service-section things-remove service-bord">
                      <div className="dont-need">
                        <img
                          src="/assets/img/office-icon.svg"
                          alt=""
                          loading="lazy"
                        />
                      </div>
                      <a href="/services/office-cleanout/">
                        <p>Office Cleanout</p>
                      </a>
                    </div>
                    <div className="service-section things-remove service-bord">
                      <div className="dont-need">
                        <img
                          src="/assets/img/shed-icon.svg"
                          alt=""
                          loading="lazy"
                        />
                      </div>
                      <a href="/services/shed-removal/">
                        <p>Shed Removal</p>
                      </a>
                    </div>
                    <div className="service-section things-remove service-bord">
                      <div className="dont-need const-sect">
                        <img
                          src="/assets/img/construction-icon.svg"
                          alt=""
                          loading="lazy"
                        />
                      </div>
                      <a href="/services/construction-debris-removal/">
                        <p>Construction Waste Removal</p>
                      </a>
                    </div>
                    <div className="service-section things-remove service-bord">
                      <div className="dont-need appartment">
                        <img
                          src="/assets/img/cleanout-icon.svg"
                          alt=""
                          loading="lazy"
                        />
                      </div>
                      <a href="/services/apartment-cleanout/">
                        <p>Apartment Cleanout</p>
                      </a>
                    </div>
                  </div>
                </div>
                <a onClick={handleScroll} style={{ cursor: "pointer" }}>
                  <p className="explore-this add-service service-bord">
                    See Additional Services &nbsp;
                    <i className="fa-solid fa-chevron-right"></i>
                  </p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        {/* ================== Junk Droid In Santa Clara Section Start HERE =========================  */}
        <div className="container junk-clara-sec" id="servicesDiv">
          <div className="row">
            <div className="col-md-12 bread-sec">
              <nav
                style={{ "--bsBreadcrumbDivider": "'>'" }}
                aria-label="breadcrumb"
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item active">Home</li>
                  <li className="breadcrumb-item" aria-current="page">
                    Locations
                  </li>
                  <li className="breadcrumb-item" aria-current="page">
                    California
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    <a href="#">Fremont, CA</a>
                  </li>
                </ol>
              </nav>
            </div>
            <div className="col-md-12">
              <div className="junk-santa">
                <h2 className="junk-rmv-heading">
                  Junk Removal in Fremont, CA
                </h2>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="4"
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    ></path>
                  </svg>
                </div>
                <p className="junk-desc">
                  Looking for professional junk removal in Fremont, CA? Junk
                  Droid is your trusted partner for fast, affordable, and
                  eco-friendly Fremont junk removal services. Whether you need
                  to get rid of unwanted items, old furniture, construction
                  debris, or even a hot tub, our experienced team is equipped to
                  handle it all. We specialize in Furniture Removal, Mattress
                  Removal, Hot Tub Removal, Yard Waste Removal, and more. With
                  same-day service, free quotes, and transparent pricing, we
                  make junk removal in Fremont, California simple and
                  stress-free.
                </p>

                <h3>Why Choose Junk Droid for Junk Removal in Fremont, CA?</h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="4"
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    ></path>
                  </svg>
                </div>
                <div className="junk-santa-desc">
                  <p>
                    <span>Affordable Pricing:</span>&nbsp;Competitive rates with
                    no hidden fees—great value for your money. <br />
                    <span>Eco-Friendly Disposal:</span>&nbsp;We recycle and
                    donate items whenever possible to reduce environmental
                    impact.
                    <br />
                    <span>Transparent Pricing:</span>&nbsp;Upfront quotes and
                    free estimates ensure no surprises.
                    <br />
                    <span>Fast & Reliable Service:</span>&nbsp;Same-day service
                    and next-day service to fit your schedule.
                    <br />
                    <span>Experienced Team:</span>&nbsp;Skilled junk removal
                    professionals ready to handle jobs of any size, from single
                    items to entire house cleanouts.
                    <br />
                    <span>Customer-Focused:</span>&nbsp;Dedicated to providing
                    great service and ensuring your satisfaction.
                    <br />
                    <span>Flexible Scheduling:</span>&nbsp;Convenient day junk
                    removal and next-day service tailored to your needs.
                  </p>
                </div>

                <FremontShowHide />
              </div>
            </div>
          </div>
        </div>
        {/* ================== Junk Droid In Santa Clara Section Ended HERE =========================  */}
        {/* ================== Leave Junk Section Start From HERE =========================  */}
        <JunkHauling />
        {/* ================== Leave Junk Section Ended From HERE =========================  */}
        {/* =================== We Serve Section Start Here =================== */}
        <div className="container-fluid map-sec city-clara serve-section">
          <div className="row">
            <div className="col-lg-6 col-md-12 we-serve">
              <h2 className="ps-0">
                Serving Fremont And surrounding <br /> communities, Including:
              </h2>
              <div className="sliderline-svg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="64"
                  height="4"
                  viewBox="0 0 64 4"
                  fill="none"
                >
                  <path
                    d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                    fill="#60BDFF"
                  ></path>
                </svg>
              </div>
              <p>Cities in the Fremont Area</p>
              <li className="city-clara">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9 10.9997C9 11.7954 9.31607 12.5584 9.87868 13.121C10.4413 13.6836 11.2044 13.9997 12 13.9997C12.7956 13.9997 13.5587 13.6836 14.1213 13.121C14.6839 12.5584 15 11.7954 15 10.9997C15 10.2041 14.6839 9.441 14.1213 8.87839C13.5587 8.31578 12.7956 7.99971 12 7.99971C11.2044 7.99971 10.4413 8.31578 9.87868 8.87839C9.31607 9.441 9 10.2041 9 10.9997Z"
                    stroke="#5E8CE3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M17.657 16.6567L13.414 20.8997C13.039 21.2743 12.5306 21.4848 12.0005 21.4848C11.4704 21.4848 10.962 21.2743 10.587 20.8997L6.343 16.6567C5.22422 15.5379 4.46234 14.1124 4.15369 12.5606C3.84504 11.0087 4.00349 9.40022 4.60901 7.93844C5.21452 6.47665 6.2399 5.22725 7.55548 4.34821C8.87107 3.46918 10.4178 3 12 3C13.5822 3 15.1289 3.46918 16.4445 4.34821C17.7601 5.22725 18.7855 6.47665 19.391 7.93844C19.9965 9.40022 20.155 11.0087 19.8463 12.5606C19.5377 14.1124 18.7758 15.5379 17.657 16.6567Z"
                    stroke="#5E8CE3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
                <a href="/newarkca/">
                  <span>Newark</span>
                </a>
              </li>
              <p>Cities in the Fremont Area</p>
              <div className="row">
                <div className="col-md-6">
                  <li>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M9 10.9997C9 11.7954 9.31607 12.5584 9.87868 13.121C10.4413 13.6836 11.2044 13.9997 12 13.9997C12.7956 13.9997 13.5587 13.6836 14.1213 13.121C14.6839 12.5584 15 11.7954 15 10.9997C15 10.2041 14.6839 9.441 14.1213 8.87839C13.5587 8.31578 12.7956 7.99971 12 7.99971C11.2044 7.99971 10.4413 8.31578 9.87868 8.87839C9.31607 9.441 9 10.2041 9 10.9997Z"
                        stroke="#5E8CE3"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M17.657 16.6567L13.414 20.8997C13.039 21.2743 12.5306 21.4848 12.0005 21.4848C11.4704 21.4848 10.962 21.2743 10.587 20.8997L6.343 16.6567C5.22422 15.5379 4.46234 14.1124 4.15369 12.5606C3.84504 11.0087 4.00349 9.40022 4.60901 7.93844C5.21452 6.47665 6.2399 5.22725 7.55548 4.34821C8.87107 3.46918 10.4178 3 12 3C13.5822 3 15.1289 3.46918 16.4445 4.34821C17.7601 5.22725 18.7855 6.47665 19.391 7.93844C19.9965 9.40022 20.155 11.0087 19.8463 12.5606C19.5377 14.1124 18.7758 15.5379 17.657 16.6567Z"
                        stroke="#5E8CE3"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <a href="/milpitasca/">
                      <span>Milpitas</span>
                    </a>
                  </li>
                  <li>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M9 10.9997C9 11.7954 9.31607 12.5584 9.87868 13.121C10.4413 13.6836 11.2044 13.9997 12 13.9997C12.7956 13.9997 13.5587 13.6836 14.1213 13.121C14.6839 12.5584 15 11.7954 15 10.9997C15 10.2041 14.6839 9.441 14.1213 8.87839C13.5587 8.31578 12.7956 7.99971 12 7.99971C11.2044 7.99971 10.4413 8.31578 9.87868 8.87839C9.31607 9.441 9 10.2041 9 10.9997Z"
                        stroke="#5E8CE3"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M17.657 16.6567L13.414 20.8997C13.039 21.2743 12.5306 21.4848 12.0005 21.4848C11.4704 21.4848 10.962 21.2743 10.587 20.8997L6.343 16.6567C5.22422 15.5379 4.46234 14.1124 4.15369 12.5606C3.84504 11.0087 4.00349 9.40022 4.60901 7.93844C5.21452 6.47665 6.2399 5.22725 7.55548 4.34821C8.87107 3.46918 10.4178 3 12 3C13.5822 3 15.1289 3.46918 16.4445 4.34821C17.7601 5.22725 18.7855 6.47665 19.391 7.93844C19.9965 9.40022 20.155 11.0087 19.8463 12.5606C19.5377 14.1124 18.7758 15.5379 17.657 16.6567Z"
                        stroke="#5E8CE3"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <a href="/santaclaraca/">
                      <span>Santa Clara</span>
                    </a>
                  </li>
                </div>
                <div className="col-md-6">
                  <li>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M9 10.9997C9 11.7954 9.31607 12.5584 9.87868 13.121C10.4413 13.6836 11.2044 13.9997 12 13.9997C12.7956 13.9997 13.5587 13.6836 14.1213 13.121C14.6839 12.5584 15 11.7954 15 10.9997C15 10.2041 14.6839 9.441 14.1213 8.87839C13.5587 8.31578 12.7956 7.99971 12 7.99971C11.2044 7.99971 10.4413 8.31578 9.87868 8.87839C9.31607 9.441 9 10.2041 9 10.9997Z"
                        stroke="#5E8CE3"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M17.657 16.6567L13.414 20.8997C13.039 21.2743 12.5306 21.4848 12.0005 21.4848C11.4704 21.4848 10.962 21.2743 10.587 20.8997L6.343 16.6567C5.22422 15.5379 4.46234 14.1124 4.15369 12.5606C3.84504 11.0087 4.00349 9.40022 4.60901 7.93844C5.21452 6.47665 6.2399 5.22725 7.55548 4.34821C8.87107 3.46918 10.4178 3 12 3C13.5822 3 15.1289 3.46918 16.4445 4.34821C17.7601 5.22725 18.7855 6.47665 19.391 7.93844C19.9965 9.40022 20.155 11.0087 19.8463 12.5606C19.5377 14.1124 18.7758 15.5379 17.657 16.6567Z"
                        stroke="#5E8CE3"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <a href="/losaltosca/">
                      <span>Los Altos</span>
                    </a>
                  </li>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 serve-map ">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d101249.4843688938!2d-122.0922166289169!3d37.5304038060246!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fbf46b7e8caf7%3A0x8ada313b89d888d4!2sFremont%2C%20CA%2C%20USA!5e0!3m2!1sen!2s!4v1739434020205!5m2!1sen!2s"
                width="600"
                height="450"
                style={{ border: "0" }}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
        {/* ==================== We Serve Section End Here =================== */}
        {/* =============== Junk Droid Proid Section Start Here ============== */}
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="proud-junk">
                <h2>
                  Junk Droid is proud to offer expert junk removal, debris
                  hauling, and clean-up services throughout the Fremont area.
                </h2>
                <div className="sliderline-svg d-flex align-item-center justify-content-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="4"
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    ></path>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="service-section things-remove rmv-junk-offer">
                <div className="dont-need junk-offer">
                  <img src="/assets/img/user-check.svg" alt="" loading="lazy" />
                </div>
                <div className="offer-proud d-flex flex-column">
                  <h3>Manager:</h3>
                  <p>Justin Lee</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-section things-remove rmv-junk-offer">
                <div className="dont-need junk-offer">
                  <img src="/assets/img/phone-call.svg" alt="" loading="lazy" />
                </div>
                <div className="offer-proud d-flex flex-column">
                  <h3>Phone Number:</h3>
                  <p>
                    <a href="tel:+14085397261">(408) 539-7261</a>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-section things-remove rmv-junk-offer border-0">
                <div className="dont-need junk-offer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="30"
                    height="30"
                    fill="none"
                    stroke="#2672FF"
                    stroke-width="1"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <rect x="2" y="4" width="20" height="16" rx="2" ry="2" />
                    <polyline points="2,6 12,13 22,6" />
                  </svg>
                </div>
                <div className="offer-proud d-flex flex-column">
                  <h3>Email:</h3>
                  <p>
                    <a href="mailto:info@junkdroid.com">info@junkdroid.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* =============== Junk Droid Proid Section Ended Here ============== */}
      </div>
      {/* Target Section 2 */}
      {/* =============== Offered Services Section Ended Here ============== */}
      <div id="section2" ref={section2Ref}>
        <div className="container-fluid offered-services">
          <div className="container services-offer">
            <div className="row">
              <div className="col-md-12">
                <div className="rmv-offer">
                  <h2>Junk Removal Services Offered in Fremont</h2>
                  <h6>TURNING CLUTTER INTO CLEAN SPACES, EVERY TIME!</h6>
                  <div className="sliderline-svg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="64"
                      height="4"
                      viewBox="0 0 64 4"
                      fill="none"
                    >
                      <path
                        d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                        fill="#60BDFF"
                      ></path>
                    </svg>
                  </div>
                  <p>
                    Homeowners and businesses trust Junk Droid for reliable and
                    professional junk removal services in Fremont. Whether it’s
                    a single item or a full property cleanout, we handle jobs of
                    all sizes with efficiency and care!
                  </p>
                </div>
              </div>
            </div>
            <JunkRemovalServices />
          </div>
        </div>
      </div>
      {/* =============== Offered Services Section Ended Here ============== */}
    </div>
  );
};
export default JumpFremont;
